import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import i18n from 'i18n-js';
import { getNamespacedUrl } from 'utils/route-utils';
import { Typography, Flex } from '@duxton-web/ui';

const { Logo } = Typography;

export default class SideBar extends Component {
  isActive(link) {
    return this.props.pathname.indexOf(link) >= 0;
  }

  renderLinks() {
    const { sidebarLinks, namespace } = this.props;

    return sidebarLinks.map(({ name, to, namespace: linkNamespace }) => {
      const linkProps = {
        key: name,
        className: this.isActive(to) ? 'active' : undefined,
      };

      // Add use external URL and anchor tag if link is namespaced
      if (namespace && namespace !== linkNamespace) {
        const url = getNamespacedUrl(linkNamespace, to);
        return (
          <a href={url} {...linkProps}>
            {i18n.t(`sidebar.${name}`)}
          </a>
        );
      }

      return (
        <Link to={to} {...linkProps}>
          {i18n.t(`sidebar.${name}`)}
        </Link>
      );
    });
  }

  render() {
    return (
      <aside className="-sidebar">
        <Flex style={{ padding: '16px 12px' }}>
          <Link to="/">
            <Logo
              fontType="solid"
              style={{
                fontWeight: 500,
                fontSize: '32px',
                fontFamily: 'Inter Grab Web',
              }}
            >
              Comms OS
            </Logo>
          </Link>
        </Flex>

        <div className="menu">{this.renderLinks()}</div>
      </aside>
    );
  }
}

SideBar.propTypes = {
  pathname: PropTypes.string.isRequired,
  sidebarLinks: PropTypes.arrayOf(
    PropTypes.shape({
      to: PropTypes.string,
      name: PropTypes.string,
      namespace: PropTypes.string,
    }),
  ).isRequired,
  namespace: PropTypes.string,
};
